// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* FALForm1.css */
.fal-form1 {
    padding: 2rem;
    max-width: 600px;
    margin: auto;
    background: #fff0f0;
    border-radius: 8px;
}

    .fal-form1 label {
        display: block;
        margin-top: 1rem;
    }

    .fal-form1 input {
        width: 100%;
        padding: 8px;
        margin-top: 4px;
    }
`, "",{"version":3,"sources":["webpack://./src/pages/demo/forms/FALForm1.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;IACI,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;IAEI;QACI,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB","sourcesContent":["/* FALForm1.css */\n.fal-form1 {\n    padding: 2rem;\n    max-width: 600px;\n    margin: auto;\n    background: #fff0f0;\n    border-radius: 8px;\n}\n\n    .fal-form1 label {\n        display: block;\n        margin-top: 1rem;\n    }\n\n    .fal-form1 input {\n        width: 100%;\n        padding: 8px;\n        margin-top: 4px;\n    }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
